import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tab, Icon, IconSize, TabProps, IconName } from '@blueprintjs/core';

import cls from './Sidebar.module.scss';

export interface SidebarItemProps extends TabProps {
  className: string;
  id: string;
  text: React.ReactNode;
  icon: IconName;
}

export function SidebarItem(props: SidebarItemProps): React.ReactElement {
  const { className, id, text, icon, ...restProps } = props;

  return (
    <Tab
      className={cx(cls.sidebarItem, className)}
      {...restProps}
      id={id}
      title={
        <div className={cls.sidebarItemTitle}>
          <Icon icon={icon} iconSize={IconSize.LARGE} />
          <span>{text}</span>
        </div>
      }
    />
  );
}

SidebarItem.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  text: PropTypes.node,
  icon: PropTypes.string,
};
